import classNames from 'classnames'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import CodiDocumentContext from 'views/Document/CodiDocumentContext'
import {renderIf} from 'views/Shared'
import {Link} from "react-router-dom";
import {paths} from 'views/MainPage/contains'
import TooltipApp from "components/TooltipApp";

const CodiSelectedRow = ({style, className}) => {
  const t = useTranslate()
  const {storage, item, ...rest} = useContext(CodiDocumentContext)
  const {row_detail} = storage || {}

  const {short_index_name, content, is_html, index_typecd} = row_detail ?? {}

  const is_content = _.get(row_detail, 'index_typecd') === 'content';

  return !!content ? (
    <div className="flex flex-col gap-2">
      <div
        style={style}
        className={classNames(
          'text-sm',
          className,
          is_html || is_content ? 'flex flex-col gap-1' : 'space-x-1 italic'
        )}>
              <span className="font-medium text-color-000">
                  {renderIf(short_index_name, `${short_index_name}: `)}
                {is_content && (
                  <span className="text-color-100 italic">
                        {_.get(row_detail, 'index_content')}
                      </span>
                )}
              </span>
        {!!!is_html && (
          <span
            className={classNames(
              'font-normal text-color-300 whitespace-pre-wrap',
              is_content && 'italic'
            )}>
          {is_content && (
            <span className="font-medium text-color-100 italic">
              {t('content')}
              {' : '}
            </span>
          )}
            {content}
        </span>
        )}
      </div>
      <div className="text-right mr-1">
        <TooltipApp title={t('view detail')} placement="left">
          <Link
            className="no-underline font-medium text-xs text-color-400 italic"
            target="_blank"
            to={{
              search: '?' + new URLSearchParams({id: row_detail?.id}).toString(),
              pathname: paths.codiRowPath.replace(
                ':codi_document_id',
                item?.idname
              ),
            }}>
            {`${t('view detail')}...`}
          </Link>
        </TooltipApp>
      </div>
    </div>
  ) : null
}

export default CodiSelectedRow
